// Import vendor modules.
// packages/alpinejs/src/scheduler.js
var $81b52a27e2d46a91$var$flushPending = false;
var $81b52a27e2d46a91$var$flushing = false;
var $81b52a27e2d46a91$var$queue = [];
var $81b52a27e2d46a91$var$lastFlushedIndex = -1;
function $81b52a27e2d46a91$var$scheduler(callback) {
    $81b52a27e2d46a91$var$queueJob(callback);
}
function $81b52a27e2d46a91$var$queueJob(job) {
    if (!$81b52a27e2d46a91$var$queue.includes(job)) $81b52a27e2d46a91$var$queue.push(job);
    $81b52a27e2d46a91$var$queueFlush();
}
function $81b52a27e2d46a91$var$dequeueJob(job) {
    let index = $81b52a27e2d46a91$var$queue.indexOf(job);
    if (index !== -1 && index > $81b52a27e2d46a91$var$lastFlushedIndex) $81b52a27e2d46a91$var$queue.splice(index, 1);
}
function $81b52a27e2d46a91$var$queueFlush() {
    if (!$81b52a27e2d46a91$var$flushing && !$81b52a27e2d46a91$var$flushPending) {
        $81b52a27e2d46a91$var$flushPending = true;
        queueMicrotask($81b52a27e2d46a91$var$flushJobs);
    }
}
function $81b52a27e2d46a91$var$flushJobs() {
    $81b52a27e2d46a91$var$flushPending = false;
    $81b52a27e2d46a91$var$flushing = true;
    for(let i = 0; i < $81b52a27e2d46a91$var$queue.length; i++){
        $81b52a27e2d46a91$var$queue[i]();
        $81b52a27e2d46a91$var$lastFlushedIndex = i;
    }
    $81b52a27e2d46a91$var$queue.length = 0;
    $81b52a27e2d46a91$var$lastFlushedIndex = -1;
    $81b52a27e2d46a91$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $81b52a27e2d46a91$var$reactive;
var $81b52a27e2d46a91$var$effect;
var $81b52a27e2d46a91$var$release;
var $81b52a27e2d46a91$var$raw;
var $81b52a27e2d46a91$var$shouldSchedule = true;
function $81b52a27e2d46a91$var$disableEffectScheduling(callback) {
    $81b52a27e2d46a91$var$shouldSchedule = false;
    callback();
    $81b52a27e2d46a91$var$shouldSchedule = true;
}
function $81b52a27e2d46a91$var$setReactivityEngine(engine) {
    $81b52a27e2d46a91$var$reactive = engine.reactive;
    $81b52a27e2d46a91$var$release = engine.release;
    $81b52a27e2d46a91$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($81b52a27e2d46a91$var$shouldSchedule) $81b52a27e2d46a91$var$scheduler(task);
                else task();
            }
        });
    $81b52a27e2d46a91$var$raw = engine.raw;
}
function $81b52a27e2d46a91$var$overrideEffect(override) {
    $81b52a27e2d46a91$var$effect = override;
}
function $81b52a27e2d46a91$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $81b52a27e2d46a91$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $81b52a27e2d46a91$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $81b52a27e2d46a91$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $81b52a27e2d46a91$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$81b52a27e2d46a91$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $81b52a27e2d46a91$var$onAttributeAddeds = [];
var $81b52a27e2d46a91$var$onElRemoveds = [];
var $81b52a27e2d46a91$var$onElAddeds = [];
function $81b52a27e2d46a91$var$onElAdded(callback) {
    $81b52a27e2d46a91$var$onElAddeds.push(callback);
}
function $81b52a27e2d46a91$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $81b52a27e2d46a91$var$onElRemoveds.push(callback);
    }
}
function $81b52a27e2d46a91$var$onAttributesAdded(callback) {
    $81b52a27e2d46a91$var$onAttributeAddeds.push(callback);
}
function $81b52a27e2d46a91$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $81b52a27e2d46a91$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $81b52a27e2d46a91$var$cleanupElement(el) {
    el._x_effects?.forEach($81b52a27e2d46a91$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $81b52a27e2d46a91$var$observer = new MutationObserver($81b52a27e2d46a91$var$onMutate);
var $81b52a27e2d46a91$var$currentlyObserving = false;
function $81b52a27e2d46a91$var$startObservingMutations() {
    $81b52a27e2d46a91$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $81b52a27e2d46a91$var$currentlyObserving = true;
}
function $81b52a27e2d46a91$var$stopObservingMutations() {
    $81b52a27e2d46a91$var$flushObserver();
    $81b52a27e2d46a91$var$observer.disconnect();
    $81b52a27e2d46a91$var$currentlyObserving = false;
}
var $81b52a27e2d46a91$var$queuedMutations = [];
function $81b52a27e2d46a91$var$flushObserver() {
    let records = $81b52a27e2d46a91$var$observer.takeRecords();
    $81b52a27e2d46a91$var$queuedMutations.push(()=>records.length > 0 && $81b52a27e2d46a91$var$onMutate(records));
    let queueLengthWhenTriggered = $81b52a27e2d46a91$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($81b52a27e2d46a91$var$queuedMutations.length === queueLengthWhenTriggered) while($81b52a27e2d46a91$var$queuedMutations.length > 0)$81b52a27e2d46a91$var$queuedMutations.shift()();
    });
}
function $81b52a27e2d46a91$var$mutateDom(callback) {
    if (!$81b52a27e2d46a91$var$currentlyObserving) return callback();
    $81b52a27e2d46a91$var$stopObservingMutations();
    let result = callback();
    $81b52a27e2d46a91$var$startObservingMutations();
    return result;
}
var $81b52a27e2d46a91$var$isCollecting = false;
var $81b52a27e2d46a91$var$deferredMutations = [];
function $81b52a27e2d46a91$var$deferMutations() {
    $81b52a27e2d46a91$var$isCollecting = true;
}
function $81b52a27e2d46a91$var$flushAndStopDeferringMutations() {
    $81b52a27e2d46a91$var$isCollecting = false;
    $81b52a27e2d46a91$var$onMutate($81b52a27e2d46a91$var$deferredMutations);
    $81b52a27e2d46a91$var$deferredMutations = [];
}
function $81b52a27e2d46a91$var$onMutate(mutations) {
    if ($81b52a27e2d46a91$var$isCollecting) {
        $81b52a27e2d46a91$var$deferredMutations = $81b52a27e2d46a91$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $81b52a27e2d46a91$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $81b52a27e2d46a91$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $81b52a27e2d46a91$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $81b52a27e2d46a91$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $81b52a27e2d46a91$var$scope(node) {
    return $81b52a27e2d46a91$var$mergeProxies($81b52a27e2d46a91$var$closestDataStack(node));
}
function $81b52a27e2d46a91$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$81b52a27e2d46a91$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $81b52a27e2d46a91$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $81b52a27e2d46a91$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $81b52a27e2d46a91$var$closestDataStack(node.parentNode);
}
function $81b52a27e2d46a91$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $81b52a27e2d46a91$var$mergeProxyTrap);
}
var $81b52a27e2d46a91$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $81b52a27e2d46a91$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $81b52a27e2d46a91$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $81b52a27e2d46a91$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $81b52a27e2d46a91$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$81b52a27e2d46a91$var$get(data2, path), (value)=>$81b52a27e2d46a91$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $81b52a27e2d46a91$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $81b52a27e2d46a91$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $81b52a27e2d46a91$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $81b52a27e2d46a91$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $81b52a27e2d46a91$var$magics = {};
function $81b52a27e2d46a91$var$magic(name, callback) {
    $81b52a27e2d46a91$var$magics[name] = callback;
}
function $81b52a27e2d46a91$var$injectMagics(obj, el) {
    let memoizedUtilities = $81b52a27e2d46a91$var$getUtilities(el);
    Object.entries($81b52a27e2d46a91$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $81b52a27e2d46a91$var$getUtilities(el) {
    let [utilities, cleanup2] = $81b52a27e2d46a91$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $81b52a27e2d46a91$var$interceptor,
        ...utilities
    };
    $81b52a27e2d46a91$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $81b52a27e2d46a91$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $81b52a27e2d46a91$var$handleError(e, el, expression);
    }
}
function $81b52a27e2d46a91$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $81b52a27e2d46a91$var$shouldAutoEvaluateFunctions = true;
function $81b52a27e2d46a91$var$dontAutoEvaluateFunctions(callback) {
    let cache = $81b52a27e2d46a91$var$shouldAutoEvaluateFunctions;
    $81b52a27e2d46a91$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $81b52a27e2d46a91$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $81b52a27e2d46a91$var$evaluate(el, expression, extras = {}) {
    let result;
    $81b52a27e2d46a91$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $81b52a27e2d46a91$var$evaluateLater(...args) {
    return $81b52a27e2d46a91$var$theEvaluatorFunction(...args);
}
var $81b52a27e2d46a91$var$theEvaluatorFunction = $81b52a27e2d46a91$var$normalEvaluator;
function $81b52a27e2d46a91$var$setEvaluator(newEvaluator) {
    $81b52a27e2d46a91$var$theEvaluatorFunction = newEvaluator;
}
function $81b52a27e2d46a91$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $81b52a27e2d46a91$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$81b52a27e2d46a91$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $81b52a27e2d46a91$var$generateEvaluatorFromFunction(dataStack, expression) : $81b52a27e2d46a91$var$generateEvaluatorFromString(dataStack, expression, el);
    return $81b52a27e2d46a91$var$tryCatch.bind(null, el, expression, evaluator);
}
function $81b52a27e2d46a91$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($81b52a27e2d46a91$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $81b52a27e2d46a91$var$runIfTypeOfFunction(receiver, result);
    };
}
var $81b52a27e2d46a91$var$evaluatorMemo = {};
function $81b52a27e2d46a91$var$generateFunctionFromString(expression, el) {
    if ($81b52a27e2d46a91$var$evaluatorMemo[expression]) return $81b52a27e2d46a91$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $81b52a27e2d46a91$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $81b52a27e2d46a91$var$evaluatorMemo[expression] = func;
    return func;
}
function $81b52a27e2d46a91$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $81b52a27e2d46a91$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $81b52a27e2d46a91$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$81b52a27e2d46a91$var$handleError(error2, el, expression));
            if (func.finished) {
                $81b52a27e2d46a91$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $81b52a27e2d46a91$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$81b52a27e2d46a91$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $81b52a27e2d46a91$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($81b52a27e2d46a91$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$81b52a27e2d46a91$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$81b52a27e2d46a91$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $81b52a27e2d46a91$var$prefixAsString = "x-";
function $81b52a27e2d46a91$var$prefix(subject = "") {
    return $81b52a27e2d46a91$var$prefixAsString + subject;
}
function $81b52a27e2d46a91$var$setPrefix(newPrefix) {
    $81b52a27e2d46a91$var$prefixAsString = newPrefix;
}
var $81b52a27e2d46a91$var$directiveHandlers = {};
function $81b52a27e2d46a91$var$directive(name, callback) {
    $81b52a27e2d46a91$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$81b52a27e2d46a91$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $81b52a27e2d46a91$var$directiveOrder.indexOf(directive2);
            $81b52a27e2d46a91$var$directiveOrder.splice(pos >= 0 ? pos : $81b52a27e2d46a91$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $81b52a27e2d46a91$var$directiveExists(name) {
    return Object.keys($81b52a27e2d46a91$var$directiveHandlers).includes(name);
}
function $81b52a27e2d46a91$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $81b52a27e2d46a91$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($81b52a27e2d46a91$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($81b52a27e2d46a91$var$outNonAlpineAttributes).map($81b52a27e2d46a91$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($81b52a27e2d46a91$var$byPriority);
    return directives2.map((directive2)=>{
        return $81b52a27e2d46a91$var$getDirectiveHandler(el, directive2);
    });
}
function $81b52a27e2d46a91$var$attributesOnly(attributes) {
    return Array.from(attributes).map($81b52a27e2d46a91$var$toTransformedAttributes()).filter((attr)=>!$81b52a27e2d46a91$var$outNonAlpineAttributes(attr));
}
var $81b52a27e2d46a91$var$isDeferringHandlers = false;
var $81b52a27e2d46a91$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $81b52a27e2d46a91$var$currentHandlerStackKey = Symbol();
function $81b52a27e2d46a91$var$deferHandlingDirectives(callback) {
    $81b52a27e2d46a91$var$isDeferringHandlers = true;
    let key = Symbol();
    $81b52a27e2d46a91$var$currentHandlerStackKey = key;
    $81b52a27e2d46a91$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($81b52a27e2d46a91$var$directiveHandlerStacks.get(key).length)$81b52a27e2d46a91$var$directiveHandlerStacks.get(key).shift()();
        $81b52a27e2d46a91$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $81b52a27e2d46a91$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $81b52a27e2d46a91$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $81b52a27e2d46a91$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $81b52a27e2d46a91$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $81b52a27e2d46a91$var$evaluateLater.bind($81b52a27e2d46a91$var$evaluateLater, el),
        evaluate: $81b52a27e2d46a91$var$evaluate.bind($81b52a27e2d46a91$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $81b52a27e2d46a91$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $81b52a27e2d46a91$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $81b52a27e2d46a91$var$getElementBoundUtilities(el);
    $81b52a27e2d46a91$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $81b52a27e2d46a91$var$isDeferringHandlers ? $81b52a27e2d46a91$var$directiveHandlerStacks.get($81b52a27e2d46a91$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $81b52a27e2d46a91$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $81b52a27e2d46a91$var$into = (i)=>i;
function $81b52a27e2d46a91$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $81b52a27e2d46a91$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $81b52a27e2d46a91$var$attributeTransformers = [];
function $81b52a27e2d46a91$var$mapAttributes(callback) {
    $81b52a27e2d46a91$var$attributeTransformers.push(callback);
}
function $81b52a27e2d46a91$var$outNonAlpineAttributes({ name: name }) {
    return $81b52a27e2d46a91$var$alpineAttributeRegex().test(name);
}
var $81b52a27e2d46a91$var$alpineAttributeRegex = ()=>new RegExp(`^${$81b52a27e2d46a91$var$prefixAsString}([^:^.]+)\\b`);
function $81b52a27e2d46a91$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($81b52a27e2d46a91$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $81b52a27e2d46a91$var$DEFAULT = "DEFAULT";
var $81b52a27e2d46a91$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $81b52a27e2d46a91$var$DEFAULT,
    "teleport"
];
function $81b52a27e2d46a91$var$byPriority(a, b) {
    let typeA = $81b52a27e2d46a91$var$directiveOrder.indexOf(a.type) === -1 ? $81b52a27e2d46a91$var$DEFAULT : a.type;
    let typeB = $81b52a27e2d46a91$var$directiveOrder.indexOf(b.type) === -1 ? $81b52a27e2d46a91$var$DEFAULT : b.type;
    return $81b52a27e2d46a91$var$directiveOrder.indexOf(typeA) - $81b52a27e2d46a91$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $81b52a27e2d46a91$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $81b52a27e2d46a91$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$81b52a27e2d46a91$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $81b52a27e2d46a91$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $81b52a27e2d46a91$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $81b52a27e2d46a91$var$started = false;
function $81b52a27e2d46a91$var$start() {
    if ($81b52a27e2d46a91$var$started) $81b52a27e2d46a91$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $81b52a27e2d46a91$var$started = true;
    if (!document.body) $81b52a27e2d46a91$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $81b52a27e2d46a91$var$dispatch(document, "alpine:init");
    $81b52a27e2d46a91$var$dispatch(document, "alpine:initializing");
    $81b52a27e2d46a91$var$startObservingMutations();
    $81b52a27e2d46a91$var$onElAdded((el)=>$81b52a27e2d46a91$var$initTree(el, $81b52a27e2d46a91$var$walk));
    $81b52a27e2d46a91$var$onElRemoved((el)=>$81b52a27e2d46a91$var$destroyTree(el));
    $81b52a27e2d46a91$var$onAttributesAdded((el, attrs)=>{
        $81b52a27e2d46a91$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$81b52a27e2d46a91$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($81b52a27e2d46a91$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $81b52a27e2d46a91$var$initTree(el);
    });
    $81b52a27e2d46a91$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $81b52a27e2d46a91$var$warnAboutMissingPlugins();
    });
}
var $81b52a27e2d46a91$var$rootSelectorCallbacks = [];
var $81b52a27e2d46a91$var$initSelectorCallbacks = [];
function $81b52a27e2d46a91$var$rootSelectors() {
    return $81b52a27e2d46a91$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $81b52a27e2d46a91$var$allSelectors() {
    return $81b52a27e2d46a91$var$rootSelectorCallbacks.concat($81b52a27e2d46a91$var$initSelectorCallbacks).map((fn)=>fn());
}
function $81b52a27e2d46a91$var$addRootSelector(selectorCallback) {
    $81b52a27e2d46a91$var$rootSelectorCallbacks.push(selectorCallback);
}
function $81b52a27e2d46a91$var$addInitSelector(selectorCallback) {
    $81b52a27e2d46a91$var$initSelectorCallbacks.push(selectorCallback);
}
function $81b52a27e2d46a91$var$closestRoot(el, includeInitSelectors = false) {
    return $81b52a27e2d46a91$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $81b52a27e2d46a91$var$allSelectors() : $81b52a27e2d46a91$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $81b52a27e2d46a91$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $81b52a27e2d46a91$var$findClosest(el.parentElement, callback);
}
function $81b52a27e2d46a91$var$isRoot(el) {
    return $81b52a27e2d46a91$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $81b52a27e2d46a91$var$initInterceptors2 = [];
function $81b52a27e2d46a91$var$interceptInit(callback) {
    $81b52a27e2d46a91$var$initInterceptors2.push(callback);
}
var $81b52a27e2d46a91$var$markerDispenser = 1;
function $81b52a27e2d46a91$var$initTree(el, walker = $81b52a27e2d46a91$var$walk, intercept = ()=>{}) {
    if ($81b52a27e2d46a91$var$findClosest(el, (i)=>i._x_ignore)) return;
    $81b52a27e2d46a91$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $81b52a27e2d46a91$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $81b52a27e2d46a91$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $81b52a27e2d46a91$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $81b52a27e2d46a91$var$destroyTree(root, walker = $81b52a27e2d46a91$var$walk) {
    walker(root, (el)=>{
        $81b52a27e2d46a91$var$cleanupElement(el);
        $81b52a27e2d46a91$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $81b52a27e2d46a91$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($81b52a27e2d46a91$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $81b52a27e2d46a91$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $81b52a27e2d46a91$var$tickStack = [];
var $81b52a27e2d46a91$var$isHolding = false;
function $81b52a27e2d46a91$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $81b52a27e2d46a91$var$isHolding || setTimeout(()=>{
            $81b52a27e2d46a91$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $81b52a27e2d46a91$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $81b52a27e2d46a91$var$releaseNextTicks() {
    $81b52a27e2d46a91$var$isHolding = false;
    while($81b52a27e2d46a91$var$tickStack.length)$81b52a27e2d46a91$var$tickStack.shift()();
}
function $81b52a27e2d46a91$var$holdNextTicks() {
    $81b52a27e2d46a91$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $81b52a27e2d46a91$var$setClasses(el, value) {
    if (Array.isArray(value)) return $81b52a27e2d46a91$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $81b52a27e2d46a91$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $81b52a27e2d46a91$var$setClasses(el, value());
    return $81b52a27e2d46a91$var$setClassesFromString(el, value);
}
function $81b52a27e2d46a91$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $81b52a27e2d46a91$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $81b52a27e2d46a91$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $81b52a27e2d46a91$var$setStylesFromObject(el, value);
    return $81b52a27e2d46a91$var$setStylesFromString(el, value);
}
function $81b52a27e2d46a91$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $81b52a27e2d46a91$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $81b52a27e2d46a91$var$setStyles(el, previousStyles);
    };
}
function $81b52a27e2d46a91$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $81b52a27e2d46a91$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $81b52a27e2d46a91$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$81b52a27e2d46a91$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $81b52a27e2d46a91$var$registerTransitionsFromHelper(el, modifiers, value);
    else $81b52a27e2d46a91$var$registerTransitionsFromClassString(el, expression, value);
});
function $81b52a27e2d46a91$var$registerTransitionsFromClassString(el, classString, stage) {
    $81b52a27e2d46a91$var$registerTransitionObject(el, $81b52a27e2d46a91$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $81b52a27e2d46a91$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $81b52a27e2d46a91$var$registerTransitionObject(el, $81b52a27e2d46a91$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $81b52a27e2d46a91$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $81b52a27e2d46a91$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $81b52a27e2d46a91$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $81b52a27e2d46a91$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $81b52a27e2d46a91$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $81b52a27e2d46a91$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $81b52a27e2d46a91$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $81b52a27e2d46a91$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $81b52a27e2d46a91$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $81b52a27e2d46a91$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $81b52a27e2d46a91$var$closestHide(parent);
}
function $81b52a27e2d46a91$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $81b52a27e2d46a91$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $81b52a27e2d46a91$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $81b52a27e2d46a91$var$once(()=>{
        $81b52a27e2d46a91$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $81b52a27e2d46a91$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $81b52a27e2d46a91$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $81b52a27e2d46a91$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $81b52a27e2d46a91$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $81b52a27e2d46a91$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $81b52a27e2d46a91$var$mutateDom(()=>{
                stages.end();
            });
            $81b52a27e2d46a91$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $81b52a27e2d46a91$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $81b52a27e2d46a91$var$isCloning = false;
function $81b52a27e2d46a91$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$81b52a27e2d46a91$var$isCloning ? fallback(...args) : callback(...args);
}
function $81b52a27e2d46a91$var$onlyDuringClone(callback) {
    return (...args)=>$81b52a27e2d46a91$var$isCloning && callback(...args);
}
var $81b52a27e2d46a91$var$interceptors = [];
function $81b52a27e2d46a91$var$interceptClone(callback) {
    $81b52a27e2d46a91$var$interceptors.push(callback);
}
function $81b52a27e2d46a91$var$cloneNode(from, to) {
    $81b52a27e2d46a91$var$interceptors.forEach((i)=>i(from, to));
    $81b52a27e2d46a91$var$isCloning = true;
    $81b52a27e2d46a91$var$dontRegisterReactiveSideEffects(()=>{
        $81b52a27e2d46a91$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $81b52a27e2d46a91$var$isCloning = false;
}
var $81b52a27e2d46a91$var$isCloningLegacy = false;
function $81b52a27e2d46a91$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $81b52a27e2d46a91$var$isCloning = true;
    $81b52a27e2d46a91$var$isCloningLegacy = true;
    $81b52a27e2d46a91$var$dontRegisterReactiveSideEffects(()=>{
        $81b52a27e2d46a91$var$cloneTree(newEl);
    });
    $81b52a27e2d46a91$var$isCloning = false;
    $81b52a27e2d46a91$var$isCloningLegacy = false;
}
function $81b52a27e2d46a91$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $81b52a27e2d46a91$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $81b52a27e2d46a91$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $81b52a27e2d46a91$var$initTree(el, shallowWalker);
}
function $81b52a27e2d46a91$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $81b52a27e2d46a91$var$effect;
    $81b52a27e2d46a91$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $81b52a27e2d46a91$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $81b52a27e2d46a91$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $81b52a27e2d46a91$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $81b52a27e2d46a91$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $81b52a27e2d46a91$var$camelCase(name) : name;
    switch(name){
        case "value":
            $81b52a27e2d46a91$var$bindInputValue(el, value);
            break;
        case "style":
            $81b52a27e2d46a91$var$bindStyles(el, value);
            break;
        case "class":
            $81b52a27e2d46a91$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $81b52a27e2d46a91$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $81b52a27e2d46a91$var$bindAttribute(el, name, value);
            break;
    }
}
function $81b52a27e2d46a91$var$bindInputValue(el, value) {
    if ($81b52a27e2d46a91$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $81b52a27e2d46a91$var$safeParseBoolean(el.value) === value;
            else el.checked = $81b52a27e2d46a91$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($81b52a27e2d46a91$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$81b52a27e2d46a91$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $81b52a27e2d46a91$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $81b52a27e2d46a91$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $81b52a27e2d46a91$var$setClasses(el, value);
}
function $81b52a27e2d46a91$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $81b52a27e2d46a91$var$setStyles(el, value);
}
function $81b52a27e2d46a91$var$bindAttributeAndProperty(el, name, value) {
    $81b52a27e2d46a91$var$bindAttribute(el, name, value);
    $81b52a27e2d46a91$var$setPropertyIfChanged(el, name, value);
}
function $81b52a27e2d46a91$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $81b52a27e2d46a91$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($81b52a27e2d46a91$var$isBooleanAttr(name)) value = name;
        $81b52a27e2d46a91$var$setIfChanged(el, name, value);
    }
}
function $81b52a27e2d46a91$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $81b52a27e2d46a91$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $81b52a27e2d46a91$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $81b52a27e2d46a91$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $81b52a27e2d46a91$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $81b52a27e2d46a91$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $81b52a27e2d46a91$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $81b52a27e2d46a91$var$isBooleanAttr(attrName) {
    return $81b52a27e2d46a91$var$booleanAttributes.has(attrName);
}
function $81b52a27e2d46a91$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $81b52a27e2d46a91$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $81b52a27e2d46a91$var$getAttributeBinding(el, name, fallback);
}
function $81b52a27e2d46a91$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $81b52a27e2d46a91$var$dontAutoEvaluateFunctions(()=>{
            return $81b52a27e2d46a91$var$evaluate(el, binding.expression);
        });
    }
    return $81b52a27e2d46a91$var$getAttributeBinding(el, name, fallback);
}
function $81b52a27e2d46a91$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($81b52a27e2d46a91$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $81b52a27e2d46a91$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $81b52a27e2d46a91$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $81b52a27e2d46a91$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $81b52a27e2d46a91$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $81b52a27e2d46a91$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $81b52a27e2d46a91$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($81b52a27e2d46a91$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($81b52a27e2d46a91$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($81b52a27e2d46a91$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $81b52a27e2d46a91$var$release(reference);
    };
}
function $81b52a27e2d46a91$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $81b52a27e2d46a91$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($81b52a27e2d46a91$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $81b52a27e2d46a91$var$stores = {};
var $81b52a27e2d46a91$var$isReactive = false;
function $81b52a27e2d46a91$var$store(name, value) {
    if (!$81b52a27e2d46a91$var$isReactive) {
        $81b52a27e2d46a91$var$stores = $81b52a27e2d46a91$var$reactive($81b52a27e2d46a91$var$stores);
        $81b52a27e2d46a91$var$isReactive = true;
    }
    if (value === void 0) return $81b52a27e2d46a91$var$stores[name];
    $81b52a27e2d46a91$var$stores[name] = value;
    $81b52a27e2d46a91$var$initInterceptors($81b52a27e2d46a91$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $81b52a27e2d46a91$var$stores[name].init();
}
function $81b52a27e2d46a91$var$getStores() {
    return $81b52a27e2d46a91$var$stores;
}
// packages/alpinejs/src/binds.js
var $81b52a27e2d46a91$var$binds = {};
function $81b52a27e2d46a91$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $81b52a27e2d46a91$var$applyBindingsObject(name, getBindings());
    else $81b52a27e2d46a91$var$binds[name] = getBindings;
    return ()=>{};
}
function $81b52a27e2d46a91$var$injectBindingProviders(obj) {
    Object.entries($81b52a27e2d46a91$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $81b52a27e2d46a91$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $81b52a27e2d46a91$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $81b52a27e2d46a91$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $81b52a27e2d46a91$var$datas = {};
function $81b52a27e2d46a91$var$data(name, callback) {
    $81b52a27e2d46a91$var$datas[name] = callback;
}
function $81b52a27e2d46a91$var$injectDataProviders(obj, context) {
    Object.entries($81b52a27e2d46a91$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $81b52a27e2d46a91$var$Alpine = {
    get reactive () {
        return $81b52a27e2d46a91$var$reactive;
    },
    get release () {
        return $81b52a27e2d46a91$var$release;
    },
    get effect () {
        return $81b52a27e2d46a91$var$effect;
    },
    get raw () {
        return $81b52a27e2d46a91$var$raw;
    },
    version: "3.14.7",
    flushAndStopDeferringMutations: $81b52a27e2d46a91$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $81b52a27e2d46a91$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $81b52a27e2d46a91$var$disableEffectScheduling,
    startObservingMutations: $81b52a27e2d46a91$var$startObservingMutations,
    stopObservingMutations: $81b52a27e2d46a91$var$stopObservingMutations,
    setReactivityEngine: $81b52a27e2d46a91$var$setReactivityEngine,
    onAttributeRemoved: $81b52a27e2d46a91$var$onAttributeRemoved,
    onAttributesAdded: $81b52a27e2d46a91$var$onAttributesAdded,
    closestDataStack: $81b52a27e2d46a91$var$closestDataStack,
    skipDuringClone: $81b52a27e2d46a91$var$skipDuringClone,
    onlyDuringClone: $81b52a27e2d46a91$var$onlyDuringClone,
    addRootSelector: $81b52a27e2d46a91$var$addRootSelector,
    addInitSelector: $81b52a27e2d46a91$var$addInitSelector,
    interceptClone: $81b52a27e2d46a91$var$interceptClone,
    addScopeToNode: $81b52a27e2d46a91$var$addScopeToNode,
    deferMutations: $81b52a27e2d46a91$var$deferMutations,
    mapAttributes: $81b52a27e2d46a91$var$mapAttributes,
    evaluateLater: $81b52a27e2d46a91$var$evaluateLater,
    interceptInit: $81b52a27e2d46a91$var$interceptInit,
    setEvaluator: $81b52a27e2d46a91$var$setEvaluator,
    mergeProxies: $81b52a27e2d46a91$var$mergeProxies,
    extractProp: $81b52a27e2d46a91$var$extractProp,
    findClosest: $81b52a27e2d46a91$var$findClosest,
    onElRemoved: $81b52a27e2d46a91$var$onElRemoved,
    closestRoot: $81b52a27e2d46a91$var$closestRoot,
    destroyTree: $81b52a27e2d46a91$var$destroyTree,
    interceptor: $81b52a27e2d46a91$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $81b52a27e2d46a91$var$transition,
    setStyles: // INTERNAL
    $81b52a27e2d46a91$var$setStyles,
    mutateDom: // INTERNAL
    $81b52a27e2d46a91$var$mutateDom,
    directive: $81b52a27e2d46a91$var$directive,
    entangle: $81b52a27e2d46a91$var$entangle,
    throttle: $81b52a27e2d46a91$var$throttle,
    debounce: $81b52a27e2d46a91$var$debounce,
    evaluate: $81b52a27e2d46a91$var$evaluate,
    initTree: $81b52a27e2d46a91$var$initTree,
    nextTick: $81b52a27e2d46a91$var$nextTick,
    prefixed: $81b52a27e2d46a91$var$prefix,
    prefix: $81b52a27e2d46a91$var$setPrefix,
    plugin: $81b52a27e2d46a91$var$plugin,
    magic: $81b52a27e2d46a91$var$magic,
    store: $81b52a27e2d46a91$var$store,
    start: $81b52a27e2d46a91$var$start,
    clone: $81b52a27e2d46a91$var$clone,
    cloneNode: // INTERNAL
    $81b52a27e2d46a91$var$cloneNode,
    // INTERNAL
    bound: $81b52a27e2d46a91$var$getBinding,
    $data: $81b52a27e2d46a91$var$scope,
    watch: $81b52a27e2d46a91$var$watch,
    walk: $81b52a27e2d46a91$var$walk,
    data: $81b52a27e2d46a91$var$data,
    bind: $81b52a27e2d46a91$var$bind2
};
var $81b52a27e2d46a91$var$alpine_default = $81b52a27e2d46a91$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $81b52a27e2d46a91$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $81b52a27e2d46a91$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $81b52a27e2d46a91$var$isBooleanAttr2 = /* @__PURE__ */ $81b52a27e2d46a91$var$makeMap($81b52a27e2d46a91$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $81b52a27e2d46a91$var$EMPTY_OBJ = Object.freeze({});
var $81b52a27e2d46a91$var$EMPTY_ARR = Object.freeze([]);
var $81b52a27e2d46a91$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $81b52a27e2d46a91$var$hasOwn = (val, key)=>$81b52a27e2d46a91$var$hasOwnProperty.call(val, key);
var $81b52a27e2d46a91$var$isArray = Array.isArray;
var $81b52a27e2d46a91$var$isMap = (val)=>$81b52a27e2d46a91$var$toTypeString(val) === "[object Map]";
var $81b52a27e2d46a91$var$isString = (val)=>typeof val === "string";
var $81b52a27e2d46a91$var$isSymbol = (val)=>typeof val === "symbol";
var $81b52a27e2d46a91$var$isObject = (val)=>val !== null && typeof val === "object";
var $81b52a27e2d46a91$var$objectToString = Object.prototype.toString;
var $81b52a27e2d46a91$var$toTypeString = (value)=>$81b52a27e2d46a91$var$objectToString.call(value);
var $81b52a27e2d46a91$var$toRawType = (value)=>{
    return $81b52a27e2d46a91$var$toTypeString(value).slice(8, -1);
};
var $81b52a27e2d46a91$var$isIntegerKey = (key)=>$81b52a27e2d46a91$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $81b52a27e2d46a91$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $81b52a27e2d46a91$var$camelizeRE = /-(\w)/g;
var $81b52a27e2d46a91$var$camelize = $81b52a27e2d46a91$var$cacheStringFunction((str)=>{
    return str.replace($81b52a27e2d46a91$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $81b52a27e2d46a91$var$hyphenateRE = /\B([A-Z])/g;
var $81b52a27e2d46a91$var$hyphenate = $81b52a27e2d46a91$var$cacheStringFunction((str)=>str.replace($81b52a27e2d46a91$var$hyphenateRE, "-$1").toLowerCase());
var $81b52a27e2d46a91$var$capitalize = $81b52a27e2d46a91$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $81b52a27e2d46a91$var$toHandlerKey = $81b52a27e2d46a91$var$cacheStringFunction((str)=>str ? `on${$81b52a27e2d46a91$var$capitalize(str)}` : ``);
var $81b52a27e2d46a91$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $81b52a27e2d46a91$var$targetMap = /* @__PURE__ */ new WeakMap();
var $81b52a27e2d46a91$var$effectStack = [];
var $81b52a27e2d46a91$var$activeEffect;
var $81b52a27e2d46a91$var$ITERATE_KEY = Symbol("iterate");
var $81b52a27e2d46a91$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $81b52a27e2d46a91$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $81b52a27e2d46a91$var$effect2(fn, options = $81b52a27e2d46a91$var$EMPTY_OBJ) {
    if ($81b52a27e2d46a91$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $81b52a27e2d46a91$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $81b52a27e2d46a91$var$stop(effect3) {
    if (effect3.active) {
        $81b52a27e2d46a91$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $81b52a27e2d46a91$var$uid = 0;
function $81b52a27e2d46a91$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$81b52a27e2d46a91$var$effectStack.includes(effect3)) {
            $81b52a27e2d46a91$var$cleanup(effect3);
            try {
                $81b52a27e2d46a91$var$enableTracking();
                $81b52a27e2d46a91$var$effectStack.push(effect3);
                $81b52a27e2d46a91$var$activeEffect = effect3;
                return fn();
            } finally{
                $81b52a27e2d46a91$var$effectStack.pop();
                $81b52a27e2d46a91$var$resetTracking();
                $81b52a27e2d46a91$var$activeEffect = $81b52a27e2d46a91$var$effectStack[$81b52a27e2d46a91$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $81b52a27e2d46a91$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $81b52a27e2d46a91$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $81b52a27e2d46a91$var$shouldTrack = true;
var $81b52a27e2d46a91$var$trackStack = [];
function $81b52a27e2d46a91$var$pauseTracking() {
    $81b52a27e2d46a91$var$trackStack.push($81b52a27e2d46a91$var$shouldTrack);
    $81b52a27e2d46a91$var$shouldTrack = false;
}
function $81b52a27e2d46a91$var$enableTracking() {
    $81b52a27e2d46a91$var$trackStack.push($81b52a27e2d46a91$var$shouldTrack);
    $81b52a27e2d46a91$var$shouldTrack = true;
}
function $81b52a27e2d46a91$var$resetTracking() {
    const last = $81b52a27e2d46a91$var$trackStack.pop();
    $81b52a27e2d46a91$var$shouldTrack = last === void 0 ? true : last;
}
function $81b52a27e2d46a91$var$track(target, type, key) {
    if (!$81b52a27e2d46a91$var$shouldTrack || $81b52a27e2d46a91$var$activeEffect === void 0) return;
    let depsMap = $81b52a27e2d46a91$var$targetMap.get(target);
    if (!depsMap) $81b52a27e2d46a91$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($81b52a27e2d46a91$var$activeEffect)) {
        dep.add($81b52a27e2d46a91$var$activeEffect);
        $81b52a27e2d46a91$var$activeEffect.deps.push(dep);
        if ($81b52a27e2d46a91$var$activeEffect.options.onTrack) $81b52a27e2d46a91$var$activeEffect.options.onTrack({
            effect: $81b52a27e2d46a91$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $81b52a27e2d46a91$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $81b52a27e2d46a91$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $81b52a27e2d46a91$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $81b52a27e2d46a91$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$81b52a27e2d46a91$var$isArray(target)) {
                    add2(depsMap.get($81b52a27e2d46a91$var$ITERATE_KEY));
                    if ($81b52a27e2d46a91$var$isMap(target)) add2(depsMap.get($81b52a27e2d46a91$var$MAP_KEY_ITERATE_KEY));
                } else if ($81b52a27e2d46a91$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$81b52a27e2d46a91$var$isArray(target)) {
                    add2(depsMap.get($81b52a27e2d46a91$var$ITERATE_KEY));
                    if ($81b52a27e2d46a91$var$isMap(target)) add2(depsMap.get($81b52a27e2d46a91$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($81b52a27e2d46a91$var$isMap(target)) add2(depsMap.get($81b52a27e2d46a91$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $81b52a27e2d46a91$var$isNonTrackableKeys = /* @__PURE__ */ $81b52a27e2d46a91$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $81b52a27e2d46a91$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($81b52a27e2d46a91$var$isSymbol));
var $81b52a27e2d46a91$var$get2 = /* @__PURE__ */ $81b52a27e2d46a91$var$createGetter();
var $81b52a27e2d46a91$var$readonlyGet = /* @__PURE__ */ $81b52a27e2d46a91$var$createGetter(true);
var $81b52a27e2d46a91$var$arrayInstrumentations = /* @__PURE__ */ $81b52a27e2d46a91$var$createArrayInstrumentations();
function $81b52a27e2d46a91$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $81b52a27e2d46a91$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$81b52a27e2d46a91$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($81b52a27e2d46a91$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $81b52a27e2d46a91$var$pauseTracking();
            const res = $81b52a27e2d46a91$var$toRaw(this)[key].apply(this, args);
            $81b52a27e2d46a91$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $81b52a27e2d46a91$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $81b52a27e2d46a91$var$shallowReadonlyMap : $81b52a27e2d46a91$var$readonlyMap : shallow ? $81b52a27e2d46a91$var$shallowReactiveMap : $81b52a27e2d46a91$var$reactiveMap).get(target)) return target;
        const targetIsArray = $81b52a27e2d46a91$var$isArray(target);
        if (!isReadonly && targetIsArray && $81b52a27e2d46a91$var$hasOwn($81b52a27e2d46a91$var$arrayInstrumentations, key)) return Reflect.get($81b52a27e2d46a91$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($81b52a27e2d46a91$var$isSymbol(key) ? $81b52a27e2d46a91$var$builtInSymbols.has(key) : $81b52a27e2d46a91$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $81b52a27e2d46a91$var$track(target, "get", key);
        if (shallow) return res;
        if ($81b52a27e2d46a91$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$81b52a27e2d46a91$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($81b52a27e2d46a91$var$isObject(res)) return isReadonly ? $81b52a27e2d46a91$var$readonly(res) : $81b52a27e2d46a91$var$reactive2(res);
        return res;
    };
}
var $81b52a27e2d46a91$var$set2 = /* @__PURE__ */ $81b52a27e2d46a91$var$createSetter();
function $81b52a27e2d46a91$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $81b52a27e2d46a91$var$toRaw(value);
            oldValue = $81b52a27e2d46a91$var$toRaw(oldValue);
            if (!$81b52a27e2d46a91$var$isArray(target) && $81b52a27e2d46a91$var$isRef(oldValue) && !$81b52a27e2d46a91$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $81b52a27e2d46a91$var$isArray(target) && $81b52a27e2d46a91$var$isIntegerKey(key) ? Number(key) < target.length : $81b52a27e2d46a91$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $81b52a27e2d46a91$var$toRaw(receiver)) {
            if (!hadKey) $81b52a27e2d46a91$var$trigger(target, "add", key, value);
            else if ($81b52a27e2d46a91$var$hasChanged(value, oldValue)) $81b52a27e2d46a91$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $81b52a27e2d46a91$var$deleteProperty(target, key) {
    const hadKey = $81b52a27e2d46a91$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $81b52a27e2d46a91$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $81b52a27e2d46a91$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$81b52a27e2d46a91$var$isSymbol(key) || !$81b52a27e2d46a91$var$builtInSymbols.has(key)) $81b52a27e2d46a91$var$track(target, "has", key);
    return result;
}
function $81b52a27e2d46a91$var$ownKeys(target) {
    $81b52a27e2d46a91$var$track(target, "iterate", $81b52a27e2d46a91$var$isArray(target) ? "length" : $81b52a27e2d46a91$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $81b52a27e2d46a91$var$mutableHandlers = {
    get: $81b52a27e2d46a91$var$get2,
    set: $81b52a27e2d46a91$var$set2,
    deleteProperty: $81b52a27e2d46a91$var$deleteProperty,
    has: $81b52a27e2d46a91$var$has,
    ownKeys: $81b52a27e2d46a91$var$ownKeys
};
var $81b52a27e2d46a91$var$readonlyHandlers = {
    get: $81b52a27e2d46a91$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $81b52a27e2d46a91$var$toReactive = (value)=>$81b52a27e2d46a91$var$isObject(value) ? $81b52a27e2d46a91$var$reactive2(value) : value;
var $81b52a27e2d46a91$var$toReadonly = (value)=>$81b52a27e2d46a91$var$isObject(value) ? $81b52a27e2d46a91$var$readonly(value) : value;
var $81b52a27e2d46a91$var$toShallow = (value)=>value;
var $81b52a27e2d46a91$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $81b52a27e2d46a91$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $81b52a27e2d46a91$var$toRaw(target);
    const rawKey = $81b52a27e2d46a91$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "get", key);
    !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $81b52a27e2d46a91$var$getProto(rawTarget);
    const wrap = isShallow ? $81b52a27e2d46a91$var$toShallow : isReadonly ? $81b52a27e2d46a91$var$toReadonly : $81b52a27e2d46a91$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $81b52a27e2d46a91$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $81b52a27e2d46a91$var$toRaw(target);
    const rawKey = $81b52a27e2d46a91$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "has", key);
    !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $81b52a27e2d46a91$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $81b52a27e2d46a91$var$track($81b52a27e2d46a91$var$toRaw(target), "iterate", $81b52a27e2d46a91$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $81b52a27e2d46a91$var$add(value) {
    value = $81b52a27e2d46a91$var$toRaw(value);
    const target = $81b52a27e2d46a91$var$toRaw(this);
    const proto = $81b52a27e2d46a91$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $81b52a27e2d46a91$var$trigger(target, "add", value, value);
    }
    return this;
}
function $81b52a27e2d46a91$var$set$1(key, value) {
    value = $81b52a27e2d46a91$var$toRaw(value);
    const target = $81b52a27e2d46a91$var$toRaw(this);
    const { has: has2, get: get3 } = $81b52a27e2d46a91$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $81b52a27e2d46a91$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $81b52a27e2d46a91$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $81b52a27e2d46a91$var$trigger(target, "add", key, value);
    else if ($81b52a27e2d46a91$var$hasChanged(value, oldValue)) $81b52a27e2d46a91$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $81b52a27e2d46a91$var$deleteEntry(key) {
    const target = $81b52a27e2d46a91$var$toRaw(this);
    const { has: has2, get: get3 } = $81b52a27e2d46a91$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $81b52a27e2d46a91$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $81b52a27e2d46a91$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $81b52a27e2d46a91$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $81b52a27e2d46a91$var$clear() {
    const target = $81b52a27e2d46a91$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $81b52a27e2d46a91$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $81b52a27e2d46a91$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $81b52a27e2d46a91$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $81b52a27e2d46a91$var$toRaw(target);
        const wrap = isShallow ? $81b52a27e2d46a91$var$toShallow : isReadonly ? $81b52a27e2d46a91$var$toReadonly : $81b52a27e2d46a91$var$toReactive;
        !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "iterate", $81b52a27e2d46a91$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $81b52a27e2d46a91$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $81b52a27e2d46a91$var$toRaw(target);
        const targetIsMap = $81b52a27e2d46a91$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $81b52a27e2d46a91$var$toShallow : isReadonly ? $81b52a27e2d46a91$var$toReadonly : $81b52a27e2d46a91$var$toReactive;
        !isReadonly && $81b52a27e2d46a91$var$track(rawTarget, "iterate", isKeyOnly ? $81b52a27e2d46a91$var$MAP_KEY_ITERATE_KEY : $81b52a27e2d46a91$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $81b52a27e2d46a91$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$81b52a27e2d46a91$var$capitalize(type)} operation ${key}failed: target is readonly.`, $81b52a27e2d46a91$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $81b52a27e2d46a91$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $81b52a27e2d46a91$var$get$1(this, key);
        },
        get size () {
            return $81b52a27e2d46a91$var$size(this);
        },
        has: $81b52a27e2d46a91$var$has$1,
        add: $81b52a27e2d46a91$var$add,
        set: $81b52a27e2d46a91$var$set$1,
        delete: $81b52a27e2d46a91$var$deleteEntry,
        clear: $81b52a27e2d46a91$var$clear,
        forEach: $81b52a27e2d46a91$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $81b52a27e2d46a91$var$get$1(this, key, false, true);
        },
        get size () {
            return $81b52a27e2d46a91$var$size(this);
        },
        has: $81b52a27e2d46a91$var$has$1,
        add: $81b52a27e2d46a91$var$add,
        set: $81b52a27e2d46a91$var$set$1,
        delete: $81b52a27e2d46a91$var$deleteEntry,
        clear: $81b52a27e2d46a91$var$clear,
        forEach: $81b52a27e2d46a91$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $81b52a27e2d46a91$var$get$1(this, key, true);
        },
        get size () {
            return $81b52a27e2d46a91$var$size(this, true);
        },
        has (key) {
            return $81b52a27e2d46a91$var$has$1.call(this, key, true);
        },
        add: $81b52a27e2d46a91$var$createReadonlyMethod("add"),
        set: $81b52a27e2d46a91$var$createReadonlyMethod("set"),
        delete: $81b52a27e2d46a91$var$createReadonlyMethod("delete"),
        clear: $81b52a27e2d46a91$var$createReadonlyMethod("clear"),
        forEach: $81b52a27e2d46a91$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $81b52a27e2d46a91$var$get$1(this, key, true, true);
        },
        get size () {
            return $81b52a27e2d46a91$var$size(this, true);
        },
        has (key) {
            return $81b52a27e2d46a91$var$has$1.call(this, key, true);
        },
        add: $81b52a27e2d46a91$var$createReadonlyMethod("add"),
        set: $81b52a27e2d46a91$var$createReadonlyMethod("set"),
        delete: $81b52a27e2d46a91$var$createReadonlyMethod("delete"),
        clear: $81b52a27e2d46a91$var$createReadonlyMethod("clear"),
        forEach: $81b52a27e2d46a91$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $81b52a27e2d46a91$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $81b52a27e2d46a91$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $81b52a27e2d46a91$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $81b52a27e2d46a91$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$81b52a27e2d46a91$var$mutableInstrumentations, $81b52a27e2d46a91$var$readonlyInstrumentations, $81b52a27e2d46a91$var$shallowInstrumentations, $81b52a27e2d46a91$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $81b52a27e2d46a91$var$createInstrumentations();
function $81b52a27e2d46a91$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $81b52a27e2d46a91$var$shallowReadonlyInstrumentations : $81b52a27e2d46a91$var$shallowInstrumentations : isReadonly ? $81b52a27e2d46a91$var$readonlyInstrumentations : $81b52a27e2d46a91$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($81b52a27e2d46a91$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $81b52a27e2d46a91$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $81b52a27e2d46a91$var$createInstrumentationGetter(false, false)
};
var $81b52a27e2d46a91$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $81b52a27e2d46a91$var$createInstrumentationGetter(true, false)
};
function $81b52a27e2d46a91$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $81b52a27e2d46a91$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $81b52a27e2d46a91$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $81b52a27e2d46a91$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $81b52a27e2d46a91$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $81b52a27e2d46a91$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $81b52a27e2d46a91$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $81b52a27e2d46a91$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $81b52a27e2d46a91$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $81b52a27e2d46a91$var$targetTypeMap($81b52a27e2d46a91$var$toRawType(value));
}
function $81b52a27e2d46a91$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $81b52a27e2d46a91$var$createReactiveObject(target, false, $81b52a27e2d46a91$var$mutableHandlers, $81b52a27e2d46a91$var$mutableCollectionHandlers, $81b52a27e2d46a91$var$reactiveMap);
}
function $81b52a27e2d46a91$var$readonly(target) {
    return $81b52a27e2d46a91$var$createReactiveObject(target, true, $81b52a27e2d46a91$var$readonlyHandlers, $81b52a27e2d46a91$var$readonlyCollectionHandlers, $81b52a27e2d46a91$var$readonlyMap);
}
function $81b52a27e2d46a91$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$81b52a27e2d46a91$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $81b52a27e2d46a91$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $81b52a27e2d46a91$var$toRaw(observed) {
    return observed && $81b52a27e2d46a91$var$toRaw(observed["__v_raw"]) || observed;
}
function $81b52a27e2d46a91$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$81b52a27e2d46a91$var$magic("nextTick", ()=>$81b52a27e2d46a91$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$81b52a27e2d46a91$var$magic("dispatch", (el)=>$81b52a27e2d46a91$var$dispatch.bind($81b52a27e2d46a91$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$81b52a27e2d46a91$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $81b52a27e2d46a91$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$81b52a27e2d46a91$var$magic("store", $81b52a27e2d46a91$var$getStores);
// packages/alpinejs/src/magics/$data.js
$81b52a27e2d46a91$var$magic("data", (el)=>$81b52a27e2d46a91$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$81b52a27e2d46a91$var$magic("root", (el)=>$81b52a27e2d46a91$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$81b52a27e2d46a91$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $81b52a27e2d46a91$var$mergeProxies($81b52a27e2d46a91$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $81b52a27e2d46a91$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $81b52a27e2d46a91$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $81b52a27e2d46a91$var$globalIdMemo = {};
function $81b52a27e2d46a91$var$findAndIncrementId(name) {
    if (!$81b52a27e2d46a91$var$globalIdMemo[name]) $81b52a27e2d46a91$var$globalIdMemo[name] = 0;
    return ++$81b52a27e2d46a91$var$globalIdMemo[name];
}
function $81b52a27e2d46a91$var$closestIdRoot(el, name) {
    return $81b52a27e2d46a91$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $81b52a27e2d46a91$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $81b52a27e2d46a91$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$81b52a27e2d46a91$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $81b52a27e2d46a91$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $81b52a27e2d46a91$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $81b52a27e2d46a91$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$81b52a27e2d46a91$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $81b52a27e2d46a91$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$81b52a27e2d46a91$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$81b52a27e2d46a91$var$warnMissingPluginMagic("Focus", "focus", "focus");
$81b52a27e2d46a91$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $81b52a27e2d46a91$var$warnMissingPluginMagic(name, magicName, slug) {
    $81b52a27e2d46a91$var$magic(magicName, (el)=>$81b52a27e2d46a91$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$81b52a27e2d46a91$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $81b52a27e2d46a91$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$81b52a27e2d46a91$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $81b52a27e2d46a91$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $81b52a27e2d46a91$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $81b52a27e2d46a91$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $81b52a27e2d46a91$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $81b52a27e2d46a91$var$skipDuringClone(()=>{
            $81b52a27e2d46a91$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $81b52a27e2d46a91$var$getTarget(expression);
        $81b52a27e2d46a91$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$81b52a27e2d46a91$var$mutateDom(()=>{
            clone2.remove();
            $81b52a27e2d46a91$var$destroyTree(clone2);
        }));
});
var $81b52a27e2d46a91$var$teleportContainerDuringClone = document.createElement("div");
function $81b52a27e2d46a91$var$getTarget(expression) {
    let target = $81b52a27e2d46a91$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $81b52a27e2d46a91$var$teleportContainerDuringClone;
    })();
    if (!target) $81b52a27e2d46a91$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $81b52a27e2d46a91$var$handler = ()=>{};
$81b52a27e2d46a91$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$81b52a27e2d46a91$var$directive("ignore", $81b52a27e2d46a91$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$81b52a27e2d46a91$var$directive("effect", $81b52a27e2d46a91$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($81b52a27e2d46a91$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $81b52a27e2d46a91$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $81b52a27e2d46a91$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $81b52a27e2d46a91$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $81b52a27e2d46a91$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $81b52a27e2d46a91$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $81b52a27e2d46a91$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $81b52a27e2d46a91$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($81b52a27e2d46a91$var$isKeyEvent(event) || $81b52a27e2d46a91$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($81b52a27e2d46a91$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $81b52a27e2d46a91$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $81b52a27e2d46a91$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $81b52a27e2d46a91$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $81b52a27e2d46a91$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $81b52a27e2d46a91$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $81b52a27e2d46a91$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $81b52a27e2d46a91$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $81b52a27e2d46a91$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $81b52a27e2d46a91$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $81b52a27e2d46a91$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($81b52a27e2d46a91$var$isClickEvent(e.type)) return false;
            if ($81b52a27e2d46a91$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $81b52a27e2d46a91$var$keyToModifiers(key) {
    if (!key) return [];
    key = $81b52a27e2d46a91$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$81b52a27e2d46a91$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $81b52a27e2d46a91$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $81b52a27e2d46a91$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $81b52a27e2d46a91$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $81b52a27e2d46a91$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($81b52a27e2d46a91$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $81b52a27e2d46a91$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $81b52a27e2d46a91$var$isCloning ? ()=>{} : $81b52a27e2d46a91$var$on(el, event, modifiers, (e)=>{
        setValue($81b52a27e2d46a91$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $81b52a27e2d46a91$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($81b52a27e2d46a91$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $81b52a27e2d46a91$var$on(el.form, "reset", [], (e)=>{
            $81b52a27e2d46a91$var$nextTick(()=>el._x_model && el._x_model.set($81b52a27e2d46a91$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $81b52a27e2d46a91$var$mutateDom(()=>$81b52a27e2d46a91$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $81b52a27e2d46a91$var$getInputValue(el, modifiers, event, currentValue) {
    return $81b52a27e2d46a91$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($81b52a27e2d46a91$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $81b52a27e2d46a91$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $81b52a27e2d46a91$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$81b52a27e2d46a91$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $81b52a27e2d46a91$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $81b52a27e2d46a91$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($81b52a27e2d46a91$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $81b52a27e2d46a91$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $81b52a27e2d46a91$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $81b52a27e2d46a91$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $81b52a27e2d46a91$var$isNumeric2(number) ? number : rawValue;
}
function $81b52a27e2d46a91$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $81b52a27e2d46a91$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $81b52a27e2d46a91$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$81b52a27e2d46a91$var$directive("cloak", (el)=>queueMicrotask(()=>$81b52a27e2d46a91$var$mutateDom(()=>el.removeAttribute($81b52a27e2d46a91$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$81b52a27e2d46a91$var$addInitSelector(()=>`[${$81b52a27e2d46a91$var$prefix("init")}]`);
$81b52a27e2d46a91$var$directive("init", $81b52a27e2d46a91$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$81b52a27e2d46a91$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $81b52a27e2d46a91$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$81b52a27e2d46a91$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $81b52a27e2d46a91$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $81b52a27e2d46a91$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$81b52a27e2d46a91$var$mapAttributes($81b52a27e2d46a91$var$startingWith(":", $81b52a27e2d46a91$var$into($81b52a27e2d46a91$var$prefix("bind:"))));
var $81b52a27e2d46a91$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $81b52a27e2d46a91$var$injectBindingProviders(bindingProviders);
        let getBindings = $81b52a27e2d46a91$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $81b52a27e2d46a91$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $81b52a27e2d46a91$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $81b52a27e2d46a91$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $81b52a27e2d46a91$var$mutateDom(()=>$81b52a27e2d46a91$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$81b52a27e2d46a91$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$81b52a27e2d46a91$var$directive("bind", $81b52a27e2d46a91$var$handler2);
function $81b52a27e2d46a91$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$81b52a27e2d46a91$var$addRootSelector(()=>`[${$81b52a27e2d46a91$var$prefix("data")}]`);
$81b52a27e2d46a91$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($81b52a27e2d46a91$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $81b52a27e2d46a91$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $81b52a27e2d46a91$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $81b52a27e2d46a91$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $81b52a27e2d46a91$var$injectMagics(data2, el);
    let reactiveData = $81b52a27e2d46a91$var$reactive(data2);
    $81b52a27e2d46a91$var$initInterceptors(reactiveData);
    let undo = $81b52a27e2d46a91$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $81b52a27e2d46a91$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $81b52a27e2d46a91$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$81b52a27e2d46a91$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $81b52a27e2d46a91$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$81b52a27e2d46a91$var$isCloning) return false;
    if ($81b52a27e2d46a91$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$81b52a27e2d46a91$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $81b52a27e2d46a91$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $81b52a27e2d46a91$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $81b52a27e2d46a91$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $81b52a27e2d46a91$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$81b52a27e2d46a91$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $81b52a27e2d46a91$var$parseForExpression(expression);
    let evaluateItems = $81b52a27e2d46a91$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $81b52a27e2d46a91$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$81b52a27e2d46a91$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$81b52a27e2d46a91$var$mutateDom(()=>{
                $81b52a27e2d46a91$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $81b52a27e2d46a91$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($81b52a27e2d46a91$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $81b52a27e2d46a91$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $81b52a27e2d46a91$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $81b52a27e2d46a91$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $81b52a27e2d46a91$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $81b52a27e2d46a91$var$mutateDom(()=>{
                $81b52a27e2d46a91$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $81b52a27e2d46a91$var$mutateDom(()=>{
                if (!elForSpot) $81b52a27e2d46a91$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $81b52a27e2d46a91$var$reactive(scope2);
            $81b52a27e2d46a91$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $81b52a27e2d46a91$var$mutateDom(()=>{
                lastEl.after(clone2);
                $81b52a27e2d46a91$var$skipDuringClone(()=>$81b52a27e2d46a91$var$initTree(clone2))();
            });
            if (typeof key === "object") $81b52a27e2d46a91$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $81b52a27e2d46a91$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $81b52a27e2d46a91$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $81b52a27e2d46a91$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $81b52a27e2d46a91$var$handler3() {}
$81b52a27e2d46a91$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $81b52a27e2d46a91$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$81b52a27e2d46a91$var$directive("ref", $81b52a27e2d46a91$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$81b52a27e2d46a91$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $81b52a27e2d46a91$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $81b52a27e2d46a91$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $81b52a27e2d46a91$var$addScopeToNode(clone2, {}, el);
        $81b52a27e2d46a91$var$mutateDom(()=>{
            el.after(clone2);
            $81b52a27e2d46a91$var$skipDuringClone(()=>$81b52a27e2d46a91$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $81b52a27e2d46a91$var$mutateDom(()=>{
                $81b52a27e2d46a91$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$81b52a27e2d46a91$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$81b52a27e2d46a91$var$setIdRoot(el, name));
});
$81b52a27e2d46a91$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$81b52a27e2d46a91$var$mapAttributes($81b52a27e2d46a91$var$startingWith("@", $81b52a27e2d46a91$var$into($81b52a27e2d46a91$var$prefix("on:"))));
$81b52a27e2d46a91$var$directive("on", $81b52a27e2d46a91$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $81b52a27e2d46a91$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $81b52a27e2d46a91$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$81b52a27e2d46a91$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$81b52a27e2d46a91$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$81b52a27e2d46a91$var$warnMissingPluginDirective("Focus", "trap", "focus");
$81b52a27e2d46a91$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $81b52a27e2d46a91$var$warnMissingPluginDirective(name, directiveName, slug) {
    $81b52a27e2d46a91$var$directive(directiveName, (el)=>$81b52a27e2d46a91$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$81b52a27e2d46a91$var$alpine_default.setEvaluator($81b52a27e2d46a91$var$normalEvaluator);
$81b52a27e2d46a91$var$alpine_default.setReactivityEngine({
    reactive: $81b52a27e2d46a91$var$reactive2,
    effect: $81b52a27e2d46a91$var$effect2,
    release: $81b52a27e2d46a91$var$stop,
    raw: $81b52a27e2d46a91$var$toRaw
});
var $81b52a27e2d46a91$export$b7ee041e4ad2afec = $81b52a27e2d46a91$var$alpine_default;
// packages/alpinejs/builds/module.js
var $81b52a27e2d46a91$export$2e2bcd8739ae039 = $81b52a27e2d46a91$export$b7ee041e4ad2afec;


var $c03357191f606f56$exports = {};
var $236ee3f3d9acda3b$exports = {};
window.TzOffsetController = function() {
    // The native timezone offset gives us the number of minutes that we'd have to add to
    // the LOCAL time in order to get the UTC time. However, we're going to use this on
    // the server, where we're already in UTC time. As such, in order to make the date
    // maths easier, we want to store the INVERSE OFFSET such that we can calculate the
    // LOCAL time from the UTC time.
    this.$el.value = -new Date().getTimezoneOffset();
};


$c03357191f606f56$exports = {
    "tzHelper": $236ee3f3d9acda3b$exports
};


var $2cd3c03c312176d6$exports = {};
var $cc6986972ee5be68$exports = {};
// Import module styles.

// Define controllers.
window.pm14ud = {
    ErrorMessage: $cc6986972ee5be68$var$ErrorMessage
};
function $cc6986972ee5be68$var$ErrorMessage() {
    return {
        init: $init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    function $init() {
        this.$el.focus();
        this.$refs.scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
}


var $21b12c6f0c584541$exports = {};
// Import module styles.

// Define controllers.
window.owvqva = {
    FlashMessage: $21b12c6f0c584541$var$FlashMessage
};
function $21b12c6f0c584541$var$FlashMessage() {
    return {
        init: init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        // In order to make sure that the page doesn't continue to show the flash message
        // on navigation (back/forward/refresh), we're going to replace the current item
        // on the history stack.
        var url = new URL(window.location.href);
        url.searchParams.delete("flash");
        url.searchParams.delete("flashData");
        window.history.replaceState({}, "", url);
        // Focus the flash message as well.
        this.$el.focus();
    }
}


var $40c6059edb7373fa$exports = {};
// Import module styles.



var $c76d867714f18fdc$exports = {};
// Define controllers.
window.lzlbk2 = {
    FormController: $c76d867714f18fdc$var$FormController
};
function $c76d867714f18fdc$var$FormController() {
    return {
        // Public properties.
        isSubmitting: false,
        // Public methods.
        init: $init,
        handleSubmit: handleSubmit
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the form.
	*/ function $init() {
        this.$el.requestSubmit(this.$refs.button);
    }
    /**
	* I handle the form submission, making sure a double-submission isn't possible.
	*/ function handleSubmit(event) {
        if (this.isSubmitting) {
            event.preventDefault();
            return;
        }
        this.isSubmitting = true;
    }
}


var $5c4c6221ca09c2ef$exports = {};
// Import module styles.

// Define controllers.
window.e0pw7v = {
    NavController: $5c4c6221ca09c2ef$var$NavController
};
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $5c4c6221ca09c2ef$var$NavController() {
    return {
        // Public properties.
        isOpen: false,
        // Public methods.
        toggleMenu: toggleMenu
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I manage the opening / closing of the menu on narrow devices.
	*/ function toggleMenu() {
        this.isOpen = !this.isOpen;
    }
}


var $7bab008810ec7b30$exports = {};
// Import module styles.

var $5170c01220c34f17$export$d845b2147404936a = function() {
    return {
        isFuzzyMatch: isFuzzyMatch,
        isFuzzyMatchMulti: isFuzzyMatchMulti,
        normalizePipeText: normalizePipeText,
        normalizeText: normalizeText
    };
    // ---
    // PUBLIC METHODS.
    // ---
    function isFuzzyMatch(target, keywords) {
        if (!keywords) return true;
        var targetChars = [
            ...target
        ];
        var searchChars = [
            ...keywords
        ];
        var searchChar = null;
        var targetChar = null;
        while(searchChar = searchChars.shift()){
            while(targetChar = targetChars.shift())if (targetChar === searchChar) {
                if (!searchChars.length) return true;
                break;
            }
            if (!targetChars.length) break;
        }
        return false;
    }
    function isFuzzyMatchMulti(targets, keywords) {
        if (!keywords) return true;
        for (var target of targets){
            if (isFuzzyMatch(target, keywords)) return true;
        }
        return false;
    }
    function normalizePipeText(input) {
        var parts = input.split("|").map((part)=>normalizeText(part)).filter((part)=>part.length);
        return parts;
    }
    function normalizeText(input) {
        return input.toLowerCase().replace(/[^\w|]+/g, "").trim();
    }
}();
var $5170c01220c34f17$export$2e2bcd8739ae039 = $5170c01220c34f17$export$d845b2147404936a;


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.dxp6cs = {
    FormController: $7bab008810ec7b30$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $7bab008810ec7b30$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $c56fff669afbceeb$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.i53zyu = {
    FormController: $c56fff669afbceeb$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $c56fff669afbceeb$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $70e1265703523db5$exports = {};
// Import module styles.



var $879cbbf078514223$exports = {};
// Import module styles.

// Define controllers.
window.vyykfq = {
    FormController: $879cbbf078514223$var$FormController
};
function $879cbbf078514223$var$FormController() {
    var host = this.$el;
    var prompts = host.querySelectorAll(".prompt-info");
    return {
        init: $init,
        syncInfoNodes: syncInfoNodes
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the form component.
	*/ function $init() {
        this.syncInfoNodes();
    }
    /**
	* I synchronize the prompt info rendering with the select.
	*/ function syncInfoNodes() {
        var value = this.$refs.select.value;
        for (var prompt of prompts){
            prompt.classList.remove("is-active");
            if (prompt.dataset.promptId === value) prompt.classList.add("is-active");
        }
    }
}


var $1a60201ac1a17863$exports = {};
// Import module styles.



var $98fb73e70e517efd$exports = {};
// Import module styles.



var $59950f5672d9a3ff$exports = {};
// Import module styles.



var $a6d7758b6a03b2d8$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.tsjor3 = {
    FormController: $a6d7758b6a03b2d8$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $a6d7758b6a03b2d8$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $85b7769487ef68cc$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.oc21uc = {
    FormController: $85b7769487ef68cc$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $85b7769487ef68cc$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $324916775c0d108f$exports = {};
// Import module styles.

// Define controllers.
window.zwdz6r = {
    FormController: $324916775c0d108f$var$FormController
};
function $324916775c0d108f$var$FormController() {
    return {
        // Public properties.
        isSubmitting: false,
        // Public methods.
        handleSubmit: handleSubmit
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I manage the form submission.
	*/ function handleSubmit(event) {
        if (this.isSubmitting || !confirm("Are you sure you want to merge these two exercises?")) {
            event.preventDefault();
            return;
        }
        this.isSubmitting = true;
    }
}


var $632f32440c317ea9$exports = {};



var $ca35fd664d3d6244$exports = {};
// Import module styles.



var $0879f1db3b4c9862$exports = {};
// Import module styles.



var $857195ad1fd6b929$exports = {};
// Import module styles.



var $750c2e488fb5d106$exports = {};
// Import module styles.



var $3375526a0bda2a45$exports = {};
// Import module styles.

// Define controllers.
window.crpu1p = {
    FormController: $3375526a0bda2a45$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $3375526a0bda2a45$var$FormController() {
    // Auto-save the form as people type.
    var form = document.querySelector(".perform-exercise");
    var submitTimer = null;
    form.addEventListener("input", prepareForAutoSubmit);
    form.addEventListener("submit", handleSubmit);
    // I handle the submit event on the form.
    function handleSubmit() {
        // If the user is submitting the form, we want to cancel any pending
        // background submit timer that is in-flight.
        clearTimeout(submitTimer);
    }
    // I setup the background timer for auto-save.
    function prepareForAutoSubmit() {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(autoSubmitForm, 750);
    }
    // I POST the form to the server in the background.
    function autoSubmitForm() {
        var formAction = form.getAttribute("action");
        var formMethod = form.getAttribute("method");
        var formData = new FormData(form);
        fetch(formAction, {
            method: formMethod,
            body: formData
        }).catch((error)=>{
            // NOTE: This only represents transport errors, not HTTP error
            // responses from the server. We don't care about server
            // responses since we're only optimistically saving the form.
            console.group("Auto submit error");
            console.error(error);
            console.groupEnd();
        });
    }
}


var $8b1da6ef532e8e1d$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.mcpkrx = {
    FormController: $8b1da6ef532e8e1d$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $8b1da6ef532e8e1d$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $22c1adaad07690d1$exports = {};
// Import module styles.



var $4258336bad89e6c5$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.mhm2qa = {
    FormController: $4258336bad89e6c5$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $4258336bad89e6c5$var$FormController() {
    var selectRecentLink = document.querySelector(".select-recent");
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var movementInputs = document.querySelectorAll("input[name='movementKind']");
    var movementKind = null;
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    for (var node of movementInputs)node.addEventListener("input", handleMovementInput);
    setMovementKind();
    handleSearchInput();
    function setMovementKind() {
        movementKind = null;
        for (var node of movementInputs)if (node.checked) movementKind = node.value;
    }
    function handleMovementInput(event) {
        setMovementKind();
        handleSearchInput();
        updateSelectRecent();
    }
    function handleSearchInput() {
        var keywords = (0, $5170c01220c34f17$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets){
            var isMatch = (0, $5170c01220c34f17$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords) && isMovementMatch(target);
            target.node.hidden = !isMatch;
        }
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
    function isMovementMatch(target) {
        return movementKind === "all" || movementKind === "push" && target.node.dataset.isPush === "yes" || movementKind === "pull" && target.node.dataset.isPull === "yes" || movementKind === "legs" && target.node.dataset.isLegs === "yes";
    }
    function updateSelectRecent() {
        var url = new window.URL(selectRecentLink.href);
        url.searchParams.set("movementKind", movementKind);
        selectRecentLink.href = url.toString();
    }
}


var $858d286d233e0b03$exports = {};
// Import module styles.

// Define controllers.
window.yqcw6t = {
    FormController: $858d286d233e0b03$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $858d286d233e0b03$var$FormController() {
    (function setupCompareToSets() {
        var form = document.querySelector("form");
        var compareToInstance = form.querySelector("input[name='compareToInstance']");
        for (var node of document.querySelectorAll("button[name='compareSets']"))node.addEventListener("click", handleCompareSetsClick);
        function handleCompareSetsClick(event) {
            var target = event.currentTarget;
            compareToInstance.value = target.value;
            form.requestSubmit();
        }
    })();
    var weightHelpNode = document.querySelector(".weight-help");
    var totalWeightNode = weightHelpNode.querySelector("input[name='totalWeight']");
    var equipmentWeightNode = weightHelpNode.querySelector("input[name='equipmentWeight']");
    var weightIncrementButtons = weightHelpNode.querySelectorAll(".weight-help-incr button");
    var isEquipmentSplitLoadedNode = weightHelpNode.querySelector("input[name='isEquipmentSplitLoaded']");
    var closeWeightHelpButtonNode = weightHelpNode.querySelector(".close-weight-help .close-only");
    var closeAndApplyWeightHelpButtonNode = weightHelpNode.querySelector(".close-weight-help .close-and-apply");
    var lastActiveWeightNode = null;
    var leftWeightsNode = weightHelpNode.querySelector(".weight-illustration__left");
    var rightWeightsNode = weightHelpNode.querySelector(".weight-illustration__right");
    var plateListNode = weightHelpNode.querySelector(".plate-list");
    var plateList45Node = plateListNode.querySelector(".plate-list__count.lb-45");
    var plateList25Node = plateListNode.querySelector(".plate-list__count.lb-25");
    var plateList10Node = plateListNode.querySelector(".plate-list__count.lb-10");
    var plateList5Node = plateListNode.querySelector(".plate-list__count.lb-5");
    var plateList2_5Node = plateListNode.querySelector(".plate-list__count.lb-2-5");
    var overflowWeightNote = weightHelpNode.querySelector(".overflow-weight-note");
    var overflowWeightNoteRemaineder = weightHelpNode.querySelector(".overflow-weight-note__remainder");
    var maxHelpNode = document.querySelector(".max-help");
    var maxHelpChoiceElement = document.querySelector("input[name='maxHelp__choice']");
    var maxHelpCloseButton = document.querySelector(".max-help__close");
    var maxHelperDebounceTimer;
    closeWeightHelpButtonNode.addEventListener("click", closeWeightHelperAsModal);
    closeAndApplyWeightHelpButtonNode.addEventListener("click", closeWeightHelperAsModal);
    totalWeightNode.addEventListener("input", updateWeightHelp);
    equipmentWeightNode.addEventListener("input", updateWeightHelp);
    isEquipmentSplitLoadedNode.addEventListener("input", updateWeightHelp);
    maxHelpCloseButton.addEventListener("click", closeMaxHelper);
    // Bind to the weight inputs and update as they are updated.
    for (var inputNode of document.querySelectorAll(".set__input[name='weight']")){
        inputNode.addEventListener("input", handleWeightInput);
        inputNode.addEventListener("input", handleMaxesInput.bind(null, "weight", true)); //handles max calculations
        inputNode.addEventListener("focus", handleWeightInput);
        inputNode.addEventListener("focus", handleWeightFocus);
        inputNode.addEventListener("input", handleChartingUpdates);
    }
    for (var inputNode of document.querySelectorAll(".set__input[name='reps']")){
        inputNode.addEventListener("input", handleMaxesInput.bind(null, "reps", true));
        inputNode.addEventListener("input", handleChartingUpdates);
    }
    // Bind the helper buttons.
    for (var openHelpNode of document.querySelectorAll(".set__help"))openHelpNode.addEventListener("click", openWeightHelperAsModal);
    // Bind to the incrementer buttons.
    for (var incrementNode of weightIncrementButtons)incrementNode.addEventListener("click", incrementWeightHelper);
    function openWeightHelperAsModal(event) {
        var parentElement = event.currentTarget.parentElement;
        var weightNode = parentElement.querySelector(".set__weight");
        var overlayNode = parentElement.querySelector(".set__overlay");
        lastActiveWeightNode = weightNode;
        // If there is no weight entered into the input, use any previous weight
        // that might be available.
        totalWeightNode.value = weightNode.value.trim() || overlayNode.textContent.trim() || "";
        updateWeightHelp();
        weightHelpNode.classList.add("modal");
        weightHelpNode.scrollTop = 0;
    // totalWeightNode.focus();
    }
    function closeMaxHelper(event) {
        maxHelpNode.classList.add('hidden');
    }
    function closeWeightHelperAsModal(event) {
        var button = event.currentTarget;
        weightHelpNode.classList.remove("modal");
        if (lastActiveWeightNode) {
            if (button === closeAndApplyWeightHelpButtonNode || !lastActiveWeightNode.value) lastActiveWeightNode.value = totalWeightNode.value;
            lastActiveWeightNode.focus();
        }
    }
    function handleWeightFocus(event) {
        for (var node of document.querySelectorAll(".set"))node.classList.remove("active");
        event.currentTarget.parentElement.parentElement.classList.add("active");
    }
    function incrementWeightHelper(event) {
        var increment = +event.currentTarget.dataset.increment;
        var currentWeight = +totalWeightNode.value || 0;
        var nextWeight = currentWeight + increment;
        totalWeightNode.value = nextWeight;
        updateWeightHelp();
    }
    function handleMaxesInput(inputType, clearTimer, event) {
        //check if maxHelpChoiceElement is checked. if not, return
        if (!maxHelpChoiceElement || !maxHelpChoiceElement.checked) return;
        if (clearTimer) {
            clearTimeout(maxHelperDebounceTimer);
            const target = event.currentTarget;
            maxHelperDebounceTimer = setTimeout(function() {
                handleMaxesInput(inputType, false, {
                    currentTarget: target
                }); // Call the function after a delay
            }, 500); // Adjust the delay (in milliseconds) as needed	
            return;
        }
        let inputValue = event.currentTarget.value || -1;
        let repsNode = null;
        let weightNode = null;
        let repsValue = -1;
        let weightValue = -1;
        var parentElement = event.currentTarget.closest('.set');
        switch(inputType){
            case 'weight':
                repsNode = parentElement.querySelector(".set__input[name='reps']");
                weightNode = event.currentTarget;
                weightValue = parseInt(inputValue);
                repsValue = parseInt(repsNode.value || -1);
                break;
            case 'reps':
                weightNode = parentElement.querySelector(".set__input[name='weight']");
                repsNode = event.currentTarget;
                weightValue = parseInt(weightNode.value || -1);
                repsValue = parseInt(inputValue);
                break;
        }
        if (repsValue > 0 && weightValue < 0) ;
        else if (weightValue > 0 && repsValue < 0) ;
        else return;
        // var formData = new FormData( form );
        var fetchPath = '?event=member.exerciseMax';
        var exerciseID = maxHelpNode.dataset.exerciseId;
        var format = 'json';
        fetch(`${fetchPath}&exercise=${exerciseID}&reps=${repsValue}&weight=${weightValue}&format=${format}`).then((response)=>{
            if (!response.ok) console.error(new Error('Network response was not ok'));
            return response.json();
        }).then((data)=>{
            //just put the json data into the maxHelpNode. we can get cuter later
            const inputElement = event.currentTarget;
            const rect = inputElement.getBoundingClientRect();
            //find children of maxHelpNode with class of max-help-child and set display to hidden
            const children = maxHelpNode.querySelectorAll('.max-help-child');
            children.forEach((child)=>{
                child.classList.add('hidden');
            });
            if (data.length > 0) {
                data = data[0];
                const reps = data.set.reps;
                const weight = data.set.weight;
                const date = data.set.date;
                const label = data.label;
                const childNode = maxHelpNode.querySelector(`.${label}`);
                //set the data values inthe the childNode elements
                if (childNode.querySelector('.rep-max')) {
                    childNode.querySelector('.rep-max').innerHTML = reps ?? '';
                    if (!reps || reps <= 0) childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
                    else childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
                }
                if (childNode.querySelector('.weight-max')) {
                    childNode.querySelector('.weight-max').innerHTML = weight ?? '';
                    if (!weight || weight <= 0) childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
                    else childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
                }
                if (childNode.querySelector('.weight-entered')) childNode.querySelector('.weight-entered').innerHTML = weightValue ?? '';
                if (childNode.querySelector('.reps-entered')) childNode.querySelector('.reps-entered').innerHTML = repsValue ?? '';
                if (childNode.querySelector('.max-achievement-date')) childNode.querySelector('.max-achievement-date').innerHTML = date ?? '';
                // remove the hidden class from the appropriate child where label = the class name
                childNode.classList.remove('hidden');
            }
            //place the node directly beneath the input. It is already absolutely positioned. need to set the top. left position will depend on the screen size and handled in the css
            maxHelpNode.style.top = rect.top + window.scrollY + inputElement.offsetHeight + 5 + 'px';
            //remove the hidden class from the node
            maxHelpNode.classList.remove('hidden');
            //set a timeout to re-hide the node after a few seconds
            setTimeout(function() {
                closeMaxHelper();
            }, 7000);
        }).catch((error)=>{
            // NOTE: This only represents transport errors, not HTTP error
            // responses from the server. We don't care about server
            // responses since we're only optimistically saving the form.
            console.group("Max Calculation Error");
            console.error(error);
            console.groupEnd();
        });
    }
    function handleWeightInput(event) {
        lastActiveWeightNode = event.currentTarget;
        totalWeightNode.value = event.currentTarget.value || "";
        updateWeightHelp();
    }
    function updateWeightHelp() {
        var totalWeight = Number(totalWeightNode.value) || 0;
        var equipmentWeight = Number(equipmentWeightNode.value) || 0;
        var loadedWeight = Math.max(totalWeight - equipmentWeight, 0);
        var isTwoSided = isEquipmentSplitLoadedNode.checked;
        var weights = {
            "45": 0,
            "25": 0,
            "10": 0,
            "5": 0,
            "2.5": 0
        };
        var remainingWeight = isTwoSided ? loadedWeight / 2 : loadedWeight;
        weights["45"] = Math.floor(remainingWeight / 45);
        remainingWeight -= weights["45"] * 45;
        weights["25"] = Math.floor(remainingWeight / 25);
        remainingWeight -= weights["25"] * 25;
        weights["10"] = Math.floor(remainingWeight / 10);
        remainingWeight -= weights["10"] * 10;
        weights["5"] = Math.floor(remainingWeight / 5);
        remainingWeight -= weights["5"] * 5;
        weights["2.5"] = Math.floor(remainingWeight / 2.5);
        remainingWeight -= weights["2.5"] * 2.5;
        // Clear both sides.
        leftWeightsNode.replaceChildren();
        rightWeightsNode.replaceChildren();
        if (remainingWeight) {
            overflowWeightNote.classList.add("active");
            overflowWeightNoteRemaineder.textContent = isTwoSided ? remainingWeight * 2 : remainingWeight;
        } else overflowWeightNote.classList.remove("active");
        // We only want to render the illustration if the number of places is
        // reasonably small. Otherwise, we might crash the browser.
        if (loadedWeight <= 1000) {
            for(var i = 0; i < weights["45"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-45");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["25"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-25");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["10"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-10");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["5"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-5");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["2.5"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-2-5");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
        }
        // Update plate list.
        if (weights["45"]) {
            plateList45Node.textContent = weights["45"];
            plateList45Node.parentNode.classList.remove("empty");
        } else {
            plateList45Node.textContent = "";
            plateList45Node.parentNode.classList.add("empty");
        }
        if (weights["25"]) {
            plateList25Node.textContent = weights["25"];
            plateList25Node.parentNode.classList.remove("empty");
        } else {
            plateList25Node.textContent = "";
            plateList25Node.parentNode.classList.add("empty");
        }
        if (weights["10"]) {
            plateList10Node.textContent = weights["10"];
            plateList10Node.parentNode.classList.remove("empty");
        } else {
            plateList10Node.textContent = "";
            plateList10Node.parentNode.classList.add("empty");
        }
        if (weights["5"]) {
            plateList5Node.textContent = weights["5"];
            plateList5Node.parentNode.classList.remove("empty");
        } else {
            plateList5Node.textContent = "";
            plateList5Node.parentNode.classList.add("empty");
        }
        if (weights["2.5"]) {
            plateList2_5Node.textContent = weights["2.5"];
            plateList2_5Node.parentNode.classList.remove("empty");
        } else {
            plateList2_5Node.textContent = "";
            plateList2_5Node.parentNode.classList.add("empty");
        }
    }
    (function setupInputmodeToggling() {
        var toggleToText = document.querySelector(".keyboard-toggle__control.text");
        var toggleToNumeric = document.querySelector(".keyboard-toggle__control.numeric");
        var tempInput = document.querySelector(".keyboard-toggle__temp");
        var setInputs = document.querySelectorAll(".set__input");
        var lastActiveInput = null;
        toggleToText.addEventListener("input", handleToggleClick);
        toggleToNumeric.addEventListener("input", handleToggleClick);
        for (var input of setInputs)input.addEventListener("focus", handleInputFocus);
        updateInputs();
        function handleInputFocus(event) {
            lastActiveInput = event.currentTarget;
        }
        function handleToggleClick(event) {
            updateInputs();
            if (lastActiveInput) {
                tempInput.focus();
                requestAnimationFrame(()=>lastActiveInput.focus());
            }
        }
        function updateInputs() {
            if (toggleToText.checked) {
                var inputMode = "text";
                var pattern = ".*";
            } else {
                var inputMode = "decimal";
                var pattern = "[0-9.]*";
            }
            for (var input of setInputs){
                input.inputMode = inputMode;
                input.pattern = pattern;
            }
        }
    })();
    for (var node of document.querySelectorAll(".set__input"))if (node.value === "") {
        node.focus();
        node.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        break;
    }
    (function setupPrevNotesCycling() {
        var notes = document.querySelectorAll(".prev-notes__info");
        var nextNote = document.querySelector(".prev-notes__nav--next");
        var prevNote = document.querySelector(".prev-notes__nav--prev");
        var activeIndex = 0;
        var maxIndex = notes.length - 1;
        if (!nextNote || !prevNote) return;
        nextNote.addEventListener("click", gotoNextNote);
        prevNote.addEventListener("click", gotoPrevNote);
        function gotoNextNote(event) {
            clearActive();
            activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            applyActive();
        }
        function gotoPrevNote(event) {
            clearActive();
            activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            applyActive();
        }
        function clearActive() {
            notes[activeIndex].classList.remove("active");
        }
        function applyActive() {
            notes[activeIndex].classList.add("active");
        }
    })();
    (function setupBackgroundSave() {
        var form = document.querySelector(".perform-exercise");
        var submitTimer = null;
        form.addEventListener("input", prepareForAutoSubmit);
        form.addEventListener("submit", handleSubmit);
        // I handle the submit event on the form.
        function handleSubmit() {
            // If the user is submitting the form, we want to cancel any pending
            // background submit timer that is in-flight.
            clearTimeout(submitTimer);
        }
        // I setup the background timer for auto-save.
        function prepareForAutoSubmit() {
            clearTimeout(submitTimer);
            submitTimer = setTimeout(autoSubmitForm, 750);
        }
        // I POST the form to the server in the background.
        function autoSubmitForm() {
            var formAction = form.getAttribute("action");
            var formMethod = form.getAttribute("method");
            var formData = new FormData(form);
            fetch(formAction, {
                method: formMethod,
                body: formData
            }).catch((error)=>{
                // NOTE: This only represents transport errors, not HTTP error
                // responses from the server. We don't care about server
                // responses since we're only optimistically saving the form.
                console.group("Auto submit error");
                console.error(error);
                console.groupEnd();
            });
        }
    })();
    class CircularProgressBar {
        constructor(elementId){
            this.el = document.getElementById(elementId);
            if (!this.el) //element was not found
            return;
            // Initialize options from the element's data attributes
            this.options = {
                current: parseFloat(this.el.getAttribute('data-current')) || 0,
                intensityMultiplier: parseFloat(this.el.getAttribute('data-intensity-multiplier')) || 0,
                max: parseFloat(this.el.getAttribute('data-max')) || 100,
                size: parseInt(this.el.getAttribute('data-size')) || 150,
                lineWidth: parseInt(this.el.getAttribute('data-line')) || 10,
                rotate: parseInt(this.el.getAttribute('data-rotate')) || 0
            };
            // Calculate initial percentage
            this.options.percent = this.options.current / this.options.max * 100;
            // Create canvas and span elements
            this.canvas = document.createElement('canvas');
            this.span = document.createElement('span');
            this.el.style.width = `${this.options.size}px`;
            this.el.style.height = `${this.options.size}px`;
            // Append elements to the parent container
            this.el.appendChild(this.span);
            this.el.appendChild(this.canvas);
            // Setup canvas context
            if (typeof G_vmlCanvasManager !== 'undefined') G_vmlCanvasManager.initElement(this.canvas);
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = this.canvas.height = this.options.size;
            // Translate and rotate context
            this.ctx.translate(this.options.size / 2, this.options.size / 2);
            this.ctx.rotate((-0.5 + this.options.rotate / 180) * Math.PI);
            // Set radius
            this.radius = (this.options.size - this.options.lineWidth) / 2;
            // Initial draw
            this.draw();
        }
        draw() {
            if (!this.el) return;
            const drawCircle = (color, lineWidth, percent)=>{
                percent = Math.min(Math.max(0, percent), 1); // Clamp between 0 and 1
                this.ctx.beginPath();
                this.ctx.arc(0, 0, this.radius, 0, Math.PI * 2 * percent, false);
                this.ctx.strokeStyle = color;
                this.ctx.lineCap = 'round'; // Line cap: round
                this.ctx.lineWidth = lineWidth;
                this.ctx.stroke();
            };
            // Clear the canvas
            this.ctx.clearRect(-this.options.size / 2, -this.options.size / 2, this.options.size, this.options.size);
            // Draw the background and progress
            drawCircle('#efefef', this.options.lineWidth, 1); // Background
            drawCircle('#4caf50', this.options.lineWidth, this.options.percent / 100); // Progress
            // Update text in the center
            this.span.textContent = `${Math.round(this.options.percent)}%`;
        }
        update(current) {
            if (!this.el) return;
            this.options.current = current;
            if (this.options.max == 0) this.options.percent = 0;
            else this.options.percent = current / this.options.max * 100;
            this.draw();
        }
        getIntensityMultiplierRatio(set1RM) {
            if (!this.el) return;
            if (this.options.intensityMultiplier === 0 || isNaN(set1RM) || set1RM === 0) return 1;
            return set1RM / this.options.intensityMultiplier;
        }
    }
    // Initialize a circular progress bar
    const volumeProgressBar = new CircularProgressBar('volume-graph');
    function handleChartingUpdates() {
        //need to hunt down all of the sets and reps and create a volume
        let totalVolume = 0;
        // Get all the sets
        const sets = document.querySelectorAll('.set');
        // Iterate over each set
        sets.forEach((set)=>{
            const weightInput = set.querySelector('.set__weight');
            const repsInput = set.querySelector('.set__reps');
            // Parse weight and reps values
            const weight = parseFloat(weightInput.value) || 0;
            const reps = parseInt(repsInput.value, 10) || 0;
            const estimated1RM = estimate1RM(weight, reps);
            // Calculate the volume for this set
            totalVolume += weight * reps * volumeProgressBar.getIntensityMultiplierRatio(estimated1RM);
        });
        // Update the progress bar
        volumeProgressBar.update(totalVolume);
    }
    handleChartingUpdates();
    /**
	 * Estimate a 1RM based on a given weight and rep count using the Brzycki Equation.
	 * Ensures that weight and reps are numeric values.
	 * This also exists in client.main.lib.ExerciseMax.cfc, but we need to use it for the real-time charting as well
	 *
	 * @param {number|string} weight - The weight used for the calculation.
	 * @param {number|string} reps - The number of reps used for the calculation.
	 * @returns {number} The estimated 1RM, or 0 if the calculation is invalid.
	*/ function estimate1RM(weight, reps) {
        // Ensure weight and reps are numeric
        weight = isNaN(weight) ? 0 : parseFloat(weight);
        reps = isNaN(reps) ? 0 : parseInt(reps, 10);
        // Using the Brzycki Equation
        const denominator = 1.0278 - 0.0278 * reps;
        if (denominator === 0) return 0;
        return weight / denominator;
    }
}


var $9af82bdee6c17399$exports = {};
// Define controllers.
window.nujwvf = {
    FormController: $9af82bdee6c17399$var$FormController
};
// Todo: This isn't really the way Alpine.js components are supposed to be built - I'm
// just trying to get all the script tags out of the views.
function $9af82bdee6c17399$var$FormController() {
    var host = this.$el;
    var movementKind = null;
    var selectAllLink = document.querySelector(".select-all");
    var checkboxes = host.querySelectorAll("input[name='movementKind']");
    var listItems = host.querySelectorAll("li[data-is-push], li[data-is-pull], li[data-is-legs]");
    for (var node of checkboxes)node.addEventListener("input", handleCheckbox);
    // Handle any initial filtering.
    setMovementKind();
    updateListFiltering();
    function setMovementKind() {
        movementKind = null;
        for (var node of checkboxes)if (node.checked) movementKind = node.value;
    }
    function handleCheckbox(event) {
        setMovementKind();
        updateListFiltering();
        updateSelectAll();
    }
    function updateListFiltering() {
        for (var node of listItems){
            var isMatch = movementKind === "all" || movementKind === "push" && node.dataset.isPush === "yes" || movementKind === "pull" && node.dataset.isPull === "yes" || movementKind === "legs" && node.dataset.isLegs === "yes";
            node.hidden = !isMatch;
        }
    }
    function updateSelectAll() {
        var url = new window.URL(selectAllLink.href);
        url.searchParams.set("movementKind", movementKind);
        selectAllLink.href = url.toString();
    }
}


$2cd3c03c312176d6$exports = {
    "common": {
        "tags": {
            "errorMessage.view": $cc6986972ee5be68$exports,
            "flashMessage.view": $21b12c6f0c584541$exports,
            "localDebugging.view": $40c6059edb7373fa$exports
        }
    },
    "auth": {
        "verifyLogin": {
            "verifyLogin.view": $c76d867714f18fdc$exports
        }
    },
    "member": {
        "common": {
            "layout.view": $5c4c6221ca09c2ef$exports
        },
        "cardioExercises": {
            "catalogList": {
                "catalogList.view": $7bab008810ec7b30$exports
            },
            "list": {
                "list.view": $c56fff669afbceeb$exports
            }
        },
        "contributors": {
            "overview": {
                "overview.view": $70e1265703523db5$exports
            }
        },
        "gratitudeJournal": {
            "create": {
                "create.view": $879cbbf078514223$exports
            }
        },
        "home": {
            "welcome": {
                "welcome.view": $1a60201ac1a17863$exports
            }
        },
        "jointBalance": {
            "overview": {
                "overview.view": $98fb73e70e517efd$exports
            }
        },
        "repRanges": {
            "overview": {
                "overview.view": $59950f5672d9a3ff$exports
            }
        },
        "resistanceExercises": {
            "catalogList": {
                "catalogList.view": $a6d7758b6a03b2d8$exports
            },
            "exerciseList": {
                "exerciseList.view": $85b7769487ef68cc$exports
            },
            "merge": {
                "merge.view": $324916775c0d108f$exports
            },
            "view": {
                "view": $632f32440c317ea9$exports
            },
            "instances": {
                "backfill": {
                    "backfill.view": $ca35fd664d3d6244$exports
                },
                "edit": {
                    "edit.view": $0879f1db3b4c9862$exports
                },
                "view": {
                    "view.view": $857195ad1fd6b929$exports
                }
            }
        },
        "workout": {
            "start": {
                "start.view": $750c2e488fb5d106$exports
            },
            "cardio": {
                "performExercise": {
                    "performExercise.view": $3375526a0bda2a45$exports
                },
                "selectExercise": {
                    "selectExercise.view": $8b1da6ef532e8e1d$exports
                },
                "selectRecentExercise": {
                    "selectRecentExercise.view": $22c1adaad07690d1$exports
                }
            },
            "resistance": {
                "selectExercise": {
                    "selectExercise.view": $4258336bad89e6c5$exports
                },
                "performExercise": {
                    "performExercise.view": $858d286d233e0b03$exports
                },
                "selectRecentExercise": {
                    "selectRecentExercise.view": $9af82bdee6c17399$exports
                }
            }
        }
    }
};


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
window.Alpine = (0, $81b52a27e2d46a91$export$2e2bcd8739ae039);
(0, $81b52a27e2d46a91$export$2e2bcd8739ae039).start();


//# sourceMappingURL=main.a5f54276.js.map
